import { render, staticRenderFns } from "./cppOficio.vue?vue&type=template&id=1a05fd4e"
import script from "./cppOficio.vue?vue&type=script&lang=js"
export * from "./cppOficio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports